<nz-modal
	nzCentered
	[(nzVisible)]="isVerifiedVisible"
	nzTitle="The first Modal"
	(nzOnCancel)="handleOk()"
	(nzOnOk)="handleOk()"
	nzWrapClassName="login-modal"
	nzWidth="600px"
	nzMaskClosable="false"
	nzKeyboard="false"
>
	<ng-container *nzModalContent>
		<div class="content-thank-you">
			<ng-container>
				<img src="../../../assets/images/verify-account.png" alt="" />
				<h1 class="modal-header">
					You’re on your way to your new career at Cloudstaff. Check your email
					to confirm your account.
				</h1>
				<p>
					Your account is still waiting for confirmation. Please check your
					email for the verification link or resend it.
				</p>

				<br />

				<button
					nz-button
					class="btn-next"
					nzType="primary"
					(click)="handleOk()"
					nzSize="large"
					nzShape="round"
					style="margin-right: 10px"
				>
					Done
				</button>

				<button
					nz-button
					class="btn-next"
					nzType="default"
					(click)="resendEmail()"
					nzSize="large"
					nzShape="round"
				>
					Resend link
				</button>
			</ng-container>
		</div>
	</ng-container>
</nz-modal>
